import { render, staticRenderFns } from "./AdminPanelDasboardDiscount.vue?vue&type=template&id=bca8fdea"
import script from "./AdminPanelDasboardDiscount.vue?vue&type=script&lang=js"
export * from "./AdminPanelDasboardDiscount.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDasboardDiscount.vue?vue&type=style&index=0&id=bca8fdea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports